export enum GuidanceSourceType {
  PRODUCTS = "products",
  SHOPIFY_COLLECTION = "shopify_collection",
}
